import React, { useContext } from "react";
import Header from "./Header";
import Footer from "./Footer";
import SideNav from "./SideNav";
import Router from "../../router";
import { useStyles } from "./style";
import Drawer from "@mui/material/Drawer";
import useIsMobile from "../../utils/hooks/useIsMobile";
import { CustomThemeContext } from "../ThemeProvider/CustomThemeProvider";
import InactivityHandler from "../InactivityHandler";
import TokenExpirationHandler from "../InactivityHandler/TokenExpirationHandler";

const MainLayout = ({ switchHeader }) => {
  const classes = useStyles();
  const { currentTheme } = useContext(CustomThemeContext);
  const isMobile = useIsMobile(768);
  const [sideNavOpen, setSideNavOpen] = React.useState(!isMobile);

  // Make sure when screen resizes, SideNav reacts
  React.useEffect(() => {
    if (isMobile) setSideNavOpen(false);
    else setSideNavOpen(true);
  }, [isMobile]);

  // Close sidebar when clicking on a menu item (mobile only)
  const handleSideNavClose = () => {
    if (isMobile) {
      setSideNavOpen(false);
    }
  };

  // Determine sidenav background based on theme
  const sideNavStyle = currentTheme === 'dark' 
    ? { backgroundColor: '#0f172a' } 
    : { backgroundColor: '#ffffff' };

  return (
    <div className={classes.layout}>
      <div className={classes.header}>
        <Header
          isMobile={isMobile}
          sideNavOpen={sideNavOpen}
          onMenuClick={() => setSideNavOpen(!sideNavOpen)}
        />
      </div>

      <div className={classes.main}>
        {/* Mobile: Use MUI Drawer for reliable touch handling */}
        {isMobile ? (
          <Drawer
            anchor="left"
            open={sideNavOpen}
            onClose={() => setSideNavOpen(false)}
            ModalProps={{
              keepMounted: true, // Better mobile performance
            }}
            PaperProps={{
              sx: {
                width: 280,
                top: '64px',
                height: 'calc(100% - 64px)',
                ...sideNavStyle,
              }
            }}
          >
            <SideNav onMenuItemClick={handleSideNavClose} isMobile={isMobile} />
          </Drawer>
        ) : (
          /* Desktop: Use regular sidebar */
          <div
            className={`${classes.sideNav} ${
              sideNavOpen ? classes.sideNavOpen : classes.sideNavClosed
            }`}
            style={sideNavStyle}
          >
            <SideNav onMenuItemClick={handleSideNavClose} />
          </div>
        )}

        <div className={classes.contentArea}>
          <Router switchHeader={switchHeader} />
        </div>
      </div>

      <Footer />
      
      <InactivityHandler 
        timeout={10}
        warningTime={120}
      />
      
      <TokenExpirationHandler />
    </div>
  );
};

export default MainLayout;
